import React from "react";
import { FaPhoneAlt } from "react-icons/fa";
import Homepage2 from "./HomePage2";
import CircleFeatures from "./circlerimages";
import AcademicPrograms from "./rankridgegrades";
import { useNavigate } from "react-router-dom";
import CommonImageSlider from "./comandata";
import { homeImages } from "./data";
// import SeoMeta from "./seometa"; // optional if you have a wrapper
import ReviewsTextOnly from "./ReviewsTextOnly";
import BlogList from "./BlogList";
import { Helmet } from "react-helmet-async"; // ✅ use Helmet instead of next/head

const seopages = {
  title:
    "Best Schools in Hyderabad With IIT-JEE & NEET Foundation | Rankridge Schools KPHB",
  description:
    "Rankridge International School – Hyderabad’s leading K–12 institution offering Pre-Primary to Grade 12 education with CBSE & State Board, IIT-JEE & NEET foundation, and holistic development. Admissions open now.",
  keywords:
    "best schools in hyderabad, rankridge school, rankridge international school, cbse schools in hyderabad, state board schools in hyderabad, pre primary school hyderabad, top primary school hyderabad, best secondary school hyderabad, best intermediate college hyderabad, iit jee foundation hyderabad, neet foundation hyderabad, competitive exam coaching hyderabad, best junior college hyderabad, mpc with iit jee coaching, bipc with neet coaching, best school near me, hyderabad schools admissions, best private schools hyderabad, cbse and state board schools, holistic education hyderabad",
  canonical_path: "https://rankridgeschools.com",
  og_image: "", // put absolute URL if possible
};

function Homepage() {
  const navigate = useNavigate();

  const closeMenu = () => {
    navigate("/form");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // pick an image string for og:image
  const ogImg = seopages.og_image || (Array.isArray(homeImages) ? homeImages[0] : homeImages);

  return (
    <>
      {/* ✅ SEO via Helmet */}
      <Helmet>
        <title>{seopages.title}</title>
        <meta name="description" content={seopages.description} />
        <meta name="keywords" content={seopages.keywords} />
        {seopages.canonical_path && (
          <link rel="canonical" href={seopages.canonical_path} />
        )}

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content={seopages.title} />
        <meta property="og:description" content={seopages.description} />
        {ogImg && <meta property="og:image" content={ogImg} />}
        {seopages.canonical_path && (
          <meta property="og:url" content={seopages.canonical_path} />
        )}
        <meta property="og:site_name" content="Rankridge Schools" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seopages.title} />
        <meta name="twitter:description" content={seopages.description} />
        {ogImg && <meta name="twitter:image" content={ogImg} />}
      </Helmet>

      <div>
        <h1 className="text-3xl text-center font-bold mt-2">
          Best Schools in Hyderabad for IIT-JEE & NEET Foundation
        </h1>

        <section
          style={{ marginTop: "-20px" }}
          className="bg-white px-4 sm:px-8 md:px-2 xl:px-4 flex flex-col-reverse md:flex-row items-center justify-between gap-1"
        >
          <div className="w-full md:w-1/2 max-w-xl text-center md:text-left space-y-5">
            <h2 className="text-4xl sm:text-4xl md:text-5xl xl:text-6xl font-bold leading-tight mt-10">
              Beyond <span className="text-[#20b2aa]">Books</span> <br />
              Building Character, Creativity &{" "}
              <span className="text-[#20b2aa]">Capability</span>
            </h2>

            <p className="text-gray-600 text-green-900 sm:text-lg md:text-base xl:text-lg capitalize">
              Empowering Young Minds with a World-Class Learning Platform,
              innovative teaching methods, and dynamic resources that spark
              curiosity, nurture creativity, and drive academic excellence at
              Rankridge International Schools in Hyderabad
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
              <a href="tel:+919959303873" className="flex items-center justify-center">
                <button className="flex font-roboto items-center justify-center gap-2 bg-[#20b2aa] text-black px-6 py-3 rounded-lg font-semibold hover:bg-gray-200 transition">
                  <FaPhoneAlt />
                  Call Now +91 99 59 303 873
                </button>
              </a>

              <button
                onClick={closeMenu}
                className="bg-green-900 text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-800 transition"
              >
                ENQUIRE NOW
              </button>
            </div>
          </div>

          <div className="w-full md:w-1/2 justify-center bg-[#20b2aa] pe-2 ps-2 mt-10">
            <h2 className="mb-5 md:mt-2 text-2xl text-center text-black font-extrabold mt-1">
              Educating Minds That<br /> will Lead the World
            </h2>
            <CommonImageSlider images={homeImages} />
          </div>
        </section>

        <section className="mt-2">
          <AcademicPrograms status={true} metaStatus={false} />
        </section>

        <section>
          <CircleFeatures />
        </section>

        <Homepage2 />
        <BlogList status={false} />
        <ReviewsTextOnly />

        {/* If you have a SeoMeta wrapper that uses Helmet, you can use it instead */}
        {/* <SeoMeta seopages={seopages} /> */}
      </div>
    </>
  );
}

export default Homepage;
